import SingleDatePicker from "components/input-range-data";
import { useFilterActions } from "../../ducks/hooks/action";
import { useFilterState } from "../../ducks/hooks/state";

type FilterKeys =
  | "state"
  | "final_term"
  | "initial_term"
  | "created_at"
  | "meta";

export default function SelectFilters() {
  const filterState = useFilterState();
  const { updateFilter } = useFilterActions();

  const handleFilterChange = (key: FilterKeys, value: string | Date | null) => {
    if (
      (key === "created_at" ||
        key === "initial_term" ||
        key === "final_term") &&
      value instanceof Date
    ) {
      const localDate = new Date(
        value.getFullYear(),
        value.getMonth(),
        value.getDate()
      );

      const yyyy = localDate.getFullYear();
      const mm = String(localDate.getMonth() + 1).padStart(2, "0");
      const dd = String(localDate.getDate()).padStart(2, "0");

      const formattedDate = `${yyyy}-${mm}-${dd}`;
      updateFilter(key, formattedDate);
    } else {
      updateFilter(key, value === "all" ? undefined : String(value));
    }
  };

  return (
    <div className="flex gap-6 flex-wrap">
      <div className="flex-1 flex flex-col gap-2 w-64">
        <label htmlFor="created-at" className="text-sm font-semibold text-gray-700">
          Criado em
        </label>
        <SingleDatePicker
          id="created-at"
          date={
            filterState.filters.created_at
              ? new Date(filterState.filters.created_at + "T00:00:00")
              : undefined
          }
          onDateChange={(date) => handleFilterChange("created_at", date || "")}
        />
      </div>

      <div className="flex-1 flex flex-col gap-2 w-64">
        <label htmlFor="initial_term" className="text-sm font-semibold text-gray-700">
          Data Inicial
        </label>
        <SingleDatePicker
          id="initial_term"
          date={
            filterState.filters.initial_term
              ? new Date(filterState.filters.initial_term + "T00:00:00")
              : undefined
          }
          onDateChange={(date) =>
            handleFilterChange("initial_term", date || "")
          }
        />
      </div>

      <div className="flex-1 flex flex-col gap-2 w-64">
        <label htmlFor="final_term" className="text-sm font-semibold text-gray-700">
          Data Final
        </label>
        <SingleDatePicker
          id="final_term"
          date={
            filterState.filters.final_term
              ? new Date(filterState.filters.final_term + "T00:00:00")
              : undefined
          }
          onDateChange={(date) => handleFilterChange("final_term", date || "")}
        />
      </div>
    </div>
  );
}
